import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import man from "../../../assets/images/dashboard/profile.jpg";
import { LI, Image, P } from "../../../AbstractElements";
import LogoutConformation from "../../Sidebar/LogoutConformation";
import { LogOut } from "react-feather";

const UserHeader = () => {
  const history = useNavigate();
  const [profile, setProfile] = useState("");
  const [name, setName] = useState("");

  const [logoutModal, setLogoutModal] = useState(false);
  const toggleLogoutModal = () => setLogoutModal(!logoutModal);

  const authenticated = JSON.parse(localStorage.getItem("authenticated"));
  const auth0_profile = JSON.parse(localStorage.getItem("auth0_profile"));

  useEffect(() => {
    setProfile(localStorage.getItem("profileURL") || man);
    setName(localStorage.getItem("Name"));
  }, []);

  const Logout = () => {
    localStorage.removeItem("profileURL");
    localStorage.removeItem("token");

    localStorage.removeItem("auth0_profile");
    localStorage.removeItem("Name");
    localStorage.setItem("authenticated", false);
    history(`${process.env.PUBLIC_URL}/login`);
  };

  const UserMenuRedirect = (redirect) => {
    history(redirect);
  };

  return (
    <div className="profile-nav onhover-dropdown p-0">
      <div className="media profile-media">
        <Image
          attrImage={{
            className: "b-r-10",
            src: `${authenticated ? auth0_profile.picture : profile}`,
            alt: "",
          }}
        />
        <div className="media-body" style={{display: "flex",justifyContent: "space-around",alignItems: "center"}}>
          <span>{authenticated ? auth0_profile.name : name}</span>
          <LogOut size={30} onClick={toggleLogoutModal} />
          {/* <P attrPara={{ className: "mb-0 font-roboto" }}>{userRole}</P> */}
        </div>
        {/* <div>
          <LogOut />
        </div> */}
      </div>
      {/* <UL attrUL={{ className: 'profile-dropdown onhover-show-div' }}>
        <LI
          attrLI={{
            onClick: () => UserMenuRedirect(`${process.env.PUBLIC_URL}/app/users/userProfile`),
          }}>
          <User />
          <span>{Account} </span>
        </LI>
        <LI
          attrLI={{
            onClick: () => UserMenuRedirect(`${process.env.PUBLIC_URL}/app/email-app`),
          }}>
          <Mail />
          <span>{Inbox}</span>
        </LI>
        <LI
          attrLI={{
            onClick: () => UserMenuRedirect(`${process.env.PUBLIC_URL}/app/todo-app/todo`),
          }}>
          <FileText />
          <span>{Taskboard}</span>
        </LI>
        <LI attrLI={{ onClick: Logout }}>
          <LogIn />
          <span>{LogOut}</span>
        </LI>
      </UL> */}
      <LogoutConformation
        LargeModaltoggle={toggleLogoutModal}
        title={"Logout"}
        Large={logoutModal}
      />
    </div>
  );
};

export default UserHeader;
